export enum UnpackSteps {
  SelectArchive = 'selectArchive',
  SelectDesing = 'SelectDesing',
}

export enum Measurments {
  Depth = 'Depth',
  Inclination = 'Inclination',
  Azimuth = 'Azimuth',
  Pressure = 'Pressure',
  PressureGradient = 'Pressure Gradient',
  Temperature = 'Temperature',
  SensorMagnetometer = 'SensorMagnetometer',
}

export const measurementQuantity: { [key in Measurments]: string } = {
  [Measurments.Depth]: 'depth',
  [Measurments.Inclination]: 'angles',
  [Measurments.Azimuth]: 'angles',
  [Measurments.Pressure]: 'pressure',
  [Measurments.PressureGradient]: 'pressureGradient',
  [Measurments.Temperature]: 'temperature',
  [Measurments.SensorMagnetometer]: 'sensorMagnetometer',
};
